import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { deleteAccount, fetchUsers } from '../../features/auth/userSlice';
import {
    FaPhoneAlt, FaMapMarkerAlt, FaWallet, FaClock,
    FaTrash,
    FaList
} from 'react-icons/fa';
import ScrollButton from '../ui/ScrollButton';
import { Link } from 'react-router-dom';
import ConfirmDeleteModal from './models/ConfirmDeleteModal';

const Users = () => {
    const { t, i18n } = useTranslation();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const dispatch = useDispatch<AppDispatch>();
    const { users } = useSelector((state: RootState) => state.user);
    dayjs.locale(i18n.language);

    useEffect(() => {
        dispatch(fetchUsers());
    }, [dispatch]);
    const handleDelete = async () => {
        if (selectedUserId !== null) {
            await dispatch(deleteAccount(selectedUserId));
            dispatch(fetchUsers());
            setSelectedUserId(null);
        }
    };

    const confirmDelete = (id: number) => {
        setSelectedUserId(id);
        setDeleteModalOpen(true);

    };
    return (
        <div>
            <div className='bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
                <h2 className='text-white text-lg font-semibold'>{t("user-list")}</h2>
            </div>
            <div className="w-full  py-2">
                <div className="space-y-4">
                    {users.map((user: any, index: number) => (
                        <div
                            key={index}
                            className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl p-4 shadow-sm hover:shadow-md transition"
                        >
                            <div className="flex items-center gap-3 w-full sm:w-1/3">
                                <img
                                    src={user.image || "/asset/pp.svg"}
                                    alt={user.name}
                                    className="w-14 h-14 rounded-full object-cover shadow"
                                />
                                <div>
                                    <h2 className="font-semibold text-gray-800 dark:text-white">{user.name}</h2>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">{user.email}</p>
                                </div>
                            </div>

                            {/* باقي البيانات */}
                            <div className="grid grid-cols-2 gap-3 w-full sm:w-2/3 text-xs mt-3 sm:mt-0">
                                <Info icon={<FaPhoneAlt />} label={t("phone")} value={user.phone} />
                                <Info
                                    icon={<FaWallet />}
                                    label={t("currency-type")}
                                    value={user.currencyCode ? user.currencyCode : t("not-specified")}
                                />
                                <Info
                                    icon={<FaMapMarkerAlt />}
                                    label={t("location")}
                                    value={
                                        <a
                                            href={`https://www.google.com/maps?q=${user.latitude},${user.longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:underline"
                                        >
                                            {user.location || t("not-specified")}
                                        </a>
                                    }
                                />
                                <Info
                                    icon={<FaClock />}
                                    label={t("joined-at")}
                                    value={dayjs(user.createAt).format("YYYY/MM/DD")}
                                />
                            </div>

                            <div className="flex gap-2 mt-3 sm:mt-0">
                                
                                <Link to={`/dashboard/user-booking-report/${user.id}`}
                                    className="flex items-center gap-1 px-3 py-1.5  text-nowrap  text-white rounded-lg text-xs bg-primary hover:bg-[#005011] transition"  >
                                    <FaList size={12} /> {t("books")}
                                </Link>
                                <button 
                                onClick={()=>confirmDelete(user.id)}
                                    className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white rounded-lg text-xs hover:bg-red-700 transition"  >
                                    <FaTrash size={12} /> {t("delete")}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div> 
            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                messageKey="delete-account-confirm"
            />
            <ScrollButton />
        </div>
    );
};

const Info = ({
    icon,
    label,
    value
}: {
    icon: React.ReactNode;
    label: string;
    value: string | number | any;
}) => (
    <div className="flex items-start gap-2 text-gray-700 dark:text-gray-300">
        <div className="mt-1 text-base text-gray-500 dark:text-gray-400">{icon}</div>
        <div>
            <div className="text-xs font-medium uppercase text-gray-400 dark:text-gray-500">{label}</div>
            <div className="text-sm font-medium">{value}</div>
        </div>
    </div>
);

export default Users;
